export function url(inp: string, query?: { [k: string]: string }) {
  if (!query) return process.env.WEBSITE_ROOT + inp
  inp += "?"
  for (let key in query) {
    inp += encodeURIComponent(key) + "=" + encodeURIComponent(query[key])
  }
  return process.env.WEBSITE_ROOT + inp
}
